import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';
import LoadingSpinner from './LoadingSpinner';

const ProtectedRoute = ({
  children,
  requiredRole = null,
  requiredPortal = null,
  fallbackPath = '/login'
}) => {
  const { isAuthenticated, isLoading, user, hasRole, hasPortalAccess, portalType } = useAuth();
  const location = useLocation();

  console.log('🛡️ ProtectedRoute check - isAuthenticated:', isAuthenticated, 'isLoading:', isLoading, 'path:', location.pathname);

  // Show loading spinner while checking authentication
  if (isLoading) {
    console.log('⏳ ProtectedRoute: Showing loading spinner');
    return <LoadingSpinner />;
  }

  // Redirect to login if not authenticated
  if (!isAuthenticated) {
    console.log('🚫 ProtectedRoute: Not authenticated, redirecting to login');
    return <Navigate to={fallbackPath} state={{ from: location }} replace />;
  }

  console.log('✅ ProtectedRoute: User is authenticated, allowing access');

  // Check portal access - use the portal type from context if not specified
  const portalToCheck = requiredPortal || portalType;
  if (portalToCheck && !hasPortalAccess(portalToCheck)) {
    return (
      <div style={{ 
        display: 'flex', 
        justifyContent: 'center', 
        alignItems: 'center', 
        height: '100vh',
        flexDirection: 'column'
      }}>
        <h2>Access Denied</h2>
        <p>You do not have access to the {portalToCheck} portal.</p>
        <p>Please contact your administrator if you believe this is an error.</p>
      </div>
    );
  }

  // Check role-based access
  if (requiredRole && !hasRole(requiredRole)) {
    return (
      <div style={{ 
        display: 'flex', 
        justifyContent: 'center', 
        alignItems: 'center', 
        height: '100vh',
        flexDirection: 'column'
      }}>
        <h2>Access Denied</h2>
        <p>You do not have the required role ({requiredRole}) to access this page.</p>
        <p>Please contact your administrator if you believe this is an error.</p>
      </div>
    );
  }

  return children;
};

export default ProtectedRoute;
